import { api } from 'common';

import { UpdateFlowConfigFormFields } from './FormFields.tsx';
import { updateFlowConfigDocumentationMarkdown } from './documentation.ts';
import { type BlockConfigProps } from '../../types.ts';

export const updateFlowConfigConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'config',
  defaultConfig: {
    entityType: '',
    entityId: '',
    practiceId: '',
  },
  configFields: {
    schema: api.FlowDefinition.UpdateFlowConfigConfigSchema,
    FormFields: UpdateFlowConfigFormFields,
  },
  documentationMarkdown: updateFlowConfigDocumentationMarkdown,
};
